export default __webpack_public_path__ + "static/media/vertical-dropdown-icon.82a02fe5.svg";